import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { IFoDotDangKyAnActionTypes } from "../../action-types/thuc-don/IFoDotDangKyAnActionTypes";
import { IFoDotDangKyAnReducer } from "../../page-state-model/thuc-don/IFoDotDangKyAnReducer";

const iniState: IFoDotDangKyAnReducer = {
    status: ePageBaseStatus.is_not_initialization,
    foDotDangKyAns: [],
    dotDangKyResponses: []
}

export const foDotDangKyAnReducer = (state: IFoDotDangKyAnReducer = iniState, action: IFoDotDangKyAnActionTypes): IFoDotDangKyAnReducer => {
    switch (action.type) {
        case "DOT_DANG_KY_AN_LOAD_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "DOT_DANG_KY_AN_LOAD_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                foDotDangKyAns: action.payload
            }
        case "DOT_DANG_KY_AN_LOAD_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                foDotDangKyAns: []
            }
        case "DOT_DANG_KY_AN_LOAD_BY_COSO_NAMHOC_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "DOT_DANG_KY_AN_LOAD_BY_COSO_NAMHOC_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                dotDangKyResponses: action.payload
            }
        case "DOT_DANG_KY_AN_LOAD_BY_COSO_NAMHOC_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                dotDangKyResponses: []
            }
        case "DOT_DANG_KY_AN_SHOW_EDIT_MODAL":
            return {
                ...state,
                editingData: action.payload,
                isShowEditModal: true
            }
        case "DOT_DANG_KY_AN_CLOSE_EDIT_MODAL":
            return {
                ...state,
                editingData: undefined,
                isShowEditModal: false
            }
        case "DOT_DANG_KY_AN_SAVE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "DOT_DANG_KY_AN_SAVE_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload
            }
        case "DOT_DANG_KY_AN_SAVE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed
            }
        case "DOT_DANG_KY_AN_DELETE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "DOT_DANG_KY_AN_DELETE_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload
            }
        case "DOT_DANG_KY_AN_DELETE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed
            }
        default:
            return state;
    }
}
